
import * as React from "react";
import {Api} from "../../../../lib/Api";

interface ICompletedButtonProps {
    order: any
    setUrl: any

}

interface ICompletedButtonState {
}

export default class CompletedButton extends React.Component<ICompletedButtonProps, ICompletedButtonState>{

    constructor(props:ICompletedButtonProps){
        super(props);
        this.state = {

        };
    }

    private completedOrder(){
        Api.call('/user/order/completedOrder', {
            orderId: this.props.order.id
        }, (result) =>{
            this.props.setUrl('/user/index');
        });
    }


    render() {

        const statuses = ['processing'];
        let order = this.props.order;

        if(!statuses.includes(order.status.key)){
            return (<></>);
        }

        return (
            <div className = "row">
                <div className = "col-md-12">
                    <p className = "processing-text">The job was done and i paid</p>
                    <button className="green_btn" onClick={() => this.completedOrder()}>I accept</button>
                </div>
            </div>
        );
    }
}
